module.exports = __webpack_public_path__ + "img/BAWS_AxeEvolving3_3_2.e6bb34c4.png";